import React, { useContext } from "react";
import { useEffect, useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FormContext } from "../../Context/FormContext";
const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets";
const GetAQuote = () => {
  const navigate = useNavigate();
  // const {  updateCompanyData, formData, companyDetails, setCompanyDetails } =
  //   useFormContext();
  const { setSignUpDetails } = useContext(FormContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    // if (true) {
    //   console.log("sign up", data);
    //   //   navigate("/candidate-details");
    //   return;
    // }
    try {
      await axios
        .post(`${process.env.REACT_APP_OFFERS_URL}/offers/demo/get/quote`, data)
        .then((res) => {
          console.log(res);

          if (res.status == 200) {
            toast.success("Request submitted successfully!", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            navigate("/");
          }
        })
        .catch((err) => console.log(err));
      // console.log("Server response:", response);
    } catch (error) {
      toast.error("Error occurred, Please try again!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const formRef = useRef(null);
  useEffect(() => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);
  return (
    <>
      <ToastContainer />
      {/* Header */}
      <div
        className={`relative w-full  bg-[url( ${digitalOceanURL}/ContactUsPageAssest/header-bg.svg)]  bg-cover bg-no-repeat h-[600px] header-container`}
      >
        <div className="header-content m-auto max-w-4xl absolute inset-0  flex flex-col justify-center items-center text-center">
          <h1 className="text-[30px] md:text-[54px] lg:text-[54px] font-medium text-white ">
            Get a Quote from HireStar.io
          </h1>
        </div>
      </div>
      {/* ---------------------------------------------------- */}
      <div className="relative  z-10 ">
        <div className="max-w-6xl relative  mx-auto ">
          <div
            ref={formRef}
            className="flex flex-col mx-4  lg:mx-0 md:mx-4 items-center justify-center min-h-screen relative  -top-20 md:-top-36 lg:-top-36 left-0 right-0 "
          >
            {/* Form Container */}
            <div className="w-full max-w-4xl  lg:p-8 md:p-8 p-6 bg-white shadow-lg rounded-[24px]">
              {/* Heading */}
              <h2 className="text-5xl text-center text-[#3A3C3D] font-semibold mb-4 mt-8">
                Get a Quote
              </h2>
              {/* Subheading */}
              <p className="text-center md:w-2/3 lg:w-2/3 mx-auto font-normal text-[#4D4F4F] mb-12">
                Flexible Packages & Pricing. Pick from 200+ checks
              </p>

              {/* Form */}
              <form onSubmit={handleSubmit(onSubmit)} className="space-y-6 ">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex flex-col">
                    <label
                      htmlFor="first-name"
                      className="text-[#797D82] text-base font-normal mb-1"
                    >
                      First Name
                    </label>
                    <input
                      {...register("first_name", {
                        required: "First name is required",
                      })}
                      type="text"
                      id="first-name"
                      className="w-full p-2 border border-[#C8C9C9] rounded-lg focus:outline-none focus:border-[#1571B7] focus:shadow-sm focus:shadow-[#1571B7]"
                    />
                    {errors.first_name && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.first_name.message}
                      </p>
                    )}
                  </div>
                  <div className="flex flex-col">
                    <label
                      htmlFor="last-name"
                      className="text-[#797D82] text-base font-normal mb-1"
                    >
                      Last Name
                    </label>
                    <input
                      {...register("last_name", {
                        required: "Last name is required",
                      })}
                      type="text"
                      id="last-name"
                      className="w-full p-2 border border-[#C8C9C9] rounded-lg focus:outline-none focus:border-[#1571B7] focus:shadow-sm focus:shadow-[#1571B7]"
                    />
                    {errors.last_name && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.last_name.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex flex-col">
                    <label
                      htmlFor="email"
                      className="text-[#797D82] text-base font-normal mb-1"
                    >
                      Company Email
                    </label>
                    <input
                      {...register("company_email", {
                        required: "Email is required",
                        pattern: {
                          value:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          message: "Invalid email address",
                        },
                      })}
                      type="email"
                      id="email"
                      className="w-full p-2 border border-[#C8C9C9] rounded-lg focus:outline-none focus:border-[#1571B7] focus:shadow-sm focus:shadow-[#1571B7]"
                    />
                    {errors.company_email && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.company_email.message}
                      </p>
                    )}
                  </div>
                  <div className="flex flex-col">
                    <label
                      htmlFor="company-name"
                      className="text-[#797D82] text-base font-normal mb-1"
                    >
                      Company Name
                    </label>
                    <input
                      {...register("company_name", {
                        required: "Company name is required",
                      })}
                      type="text"
                      id="company-name"
                      className="w-full p-2 border border-[#C8C9C9] rounded-lg focus:outline-none focus:border-[#1571B7] focus:shadow-sm focus:shadow-[#1571B7]"
                    />
                    {errors.company_name && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.company_name.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="flex flex-col">
                  <label
                    htmlFor="phone-number"
                    className="text-[#797D82] text-base font-normal mb-1"
                  >
                    Mobile No.
                    <p className="text-[#9C9EA2] text-sm my-1 font-normal">
                      include dialing code eg. +91 for India
                    </p>
                  </label>
                  <div className="flex border border-[#C8C9C9] rounded-lg focus-within:border-[#1571B7] focus-within:shadow-sm focus-within:shadow-[#1571B7]">
                    <select
                      id="dialing-code"
                      className="p-2 border-r-0 appearance-none bg-transparent pr-8 focus:outline-none"
                      style={{
                        backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="%23797D82" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>')`,
                        backgroundPosition: "right 0.4rem center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "1.5rem",
                        borderRadius: "0.8rem",
                      }}
                    >
                      <option value="+91">+91</option>
                    </select>
                    <span className="w-[1px] my-2 bg-[#797D82]"></span>
                    <input
                      {...register("mobile_number", {
                        required: "Phone number is required",
                        pattern: {
                          value: /^[0-9]{9,15}$/,
                          message: "Invalid phone number",
                        },
                      })}
                      type="tel"
                      id="phone-number"
                      className="w-full p-2 border-none rounded-r-lg focus:outline-none focus:ring-0"
                      inputMode="numeric"
                      maxLength={10}
                    />
                  </div>
                  {(errors.dialing_code || errors.mobile_number) && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.dialing_code?.message ||
                        errors.mobile_number?.message}
                    </p>
                  )}
                </div>

                <div className="grid grid-cols-1 gap-4">
                  <div className="flex flex-col">
                    <label
                      htmlFor="employee-count"
                      className="text-[#797D82] text-base font-normal mb-1"
                    >
                      Expected checks per year
                    </label>
                    <div className="relative focus-within:border-[#1571B7] focus-within:shadow-sm focus-within:shadow-[#1571B7] border border-gray-300 rounded-lg">
                      <select
                        {...register("checks_per_year", {
                          required: "Please select an option",
                        })}
                        id="checks-per-year"
                        className="w-full p-2 border-none rounded-lg focus:outline-none appearance-none pr-8"
                        style={{
                          backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="%23797D82" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>')`,
                          backgroundPosition: "right 1rem center",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "1.5rem",
                        }}
                      >
                        <option value="">Select Option</option>
                        <option value="1-10">1-10</option>
                        <option value="11-25">11-25</option>
                        <option value="26-50">26-50</option>
                        <option value="51-299">51-299</option>
                        <option value="300-1000">300-1000</option>
                        <option value="1000+">1000+</option>
                      </select>
                    </div>
                    {errors.checks_per_year && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.checks_per_year.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="text-center">
                  <button
                    type="submit"
                    className="self-center book_demo_btn home_button mb-14 px-6 py-3.5 mt-4 ml-2.5 max-w-full text-base font-medium text-white shadow-sm rounded-[61px] w-[182px] max-md:px-5 max-md:mt-10"
                  >
                    Continue
                  </button>
                </div>
              </form>
              {/* ------------------------------------------------------------- */}
              {/* <form onSubmit={handleSubmit} className="space-y-6">
                 
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex flex-col">
                      <label
                        htmlFor="first-name"
                        className="text-[#797D82] text-base font-normal mb-1"
                      >
                        First Name
                      </label>
                      <input
                        type="text"
                        id="first-name"
                        value={companyDetails.first_name}
                        onChange={(e) =>
                          updateCompanyData("first_name", e.target.value)
                        }
                        ref={(el) => (inputRefs.current["first_name"] = el)}
                        className="w-full p-2 border border-[#C8C9C9] rounded-lg focus:outline-none focus:border-[#1571B7] focus:shadow-sm focus:shadow-[#1571B7]"
                      />
                      {errors.first_name && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.first_name}
                        </p>
                      )}
                    </div>
                    <div className="flex flex-col">
                      <label
                        htmlFor="last-name"
                        className="text-[#797D82] text-base font-normal mb-1"
                      >
                        Last Name
                      </label>
                      <input
                        type="text"
                        id="last-name"
                        value={companyDetails.last_name}
                        ref={(el) => (inputRefs.current["last_name"] = el)}
                        onChange={(e) =>
                          updateCompanyData("last_name", e.target.value)
                        }
                        className="w-full p-2 border border-[#C8C9C9] rounded-lg focus:outline-none focus:border-[#1571B7] focus:shadow-sm focus:shadow-[#1571B7]"
                      />
                      {errors.last_name && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.last_name}
                        </p>
                      )}
                    </div>
                  </div>
  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex flex-col">
                      <label
                        htmlFor="email"
                        className="text-[#797D82] text-base font-normal mb-1"
                      >
                        Company Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        value={companyDetails.companyEmail}
                        onChange={(e) =>
                          updateCompanyData("companyEmail", e.target.value)
                        }
                        ref={(el) => (inputRefs.current["companyEmail"] = el)}
                        className="w-full p-2 border border-[#C8C9C9] rounded-lg focus:outline-none focus:border-[#1571B7] focus:shadow-sm focus:shadow-[#1571B7]"
                      />
                      {errors.companyEmail && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.companyEmail}
                        </p>
                      )}
                    </div>
                    <div className="flex flex-col">
                      <label
                        htmlFor="company-name"
                        className="text-[#797D82] text-base font-normal mb-1"
                      >
                        Company Name
                      </label>
                      <input
                        type="text"
                        id="company-name"
                        value={companyDetails.companyName}
                        onChange={(e) =>
                          updateCompanyData("companyName", e.target.value)
                        }
                        ref={(el) => (inputRefs.current["companyName"] = el)}
                        className="w-full p-2 border border-[#C8C9C9] rounded-lg focus:outline-none focus:border-[#1571B7] focus:shadow-sm focus:shadow-[#1571B7]"
                      />
                      {errors.companyName && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.company촠Name}
                        </p>
                      )}
                    </div>
                  </div>
  
                
                  <div className="flex flex-col">
                    <label
                      htmlFor="phone-number"
                      className="text-[#797D82] text-base font-normal mb-1"
                    >
                      Mobile No.
                      <p className="text-[#9C9EA2] text-sm my-1 font-normal">
                        include dialing code eg. +91 for India
                      </p>
                    </label>
                    <div className="flex border border-[#C8C9C9] rounded-lg focus-within:border-[#1571B7] focus-within:shadow-sm focus-within:shadow-[#1571B7]">
                      <select
                        id="dialing-code"
                        // value={formData.dialing_code}
                        // onChange={(e) =>
                        //    updateCompanyData("dialing_code", e.target.value)
                        // }
                        className="p-2 border-r-0 appearance-none bg-transparent pr-8 focus:outline-none"
                        style={{
                          backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="%23797D82" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>')`,
                          backgroundPosition: "right 0.4rem center",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "1.5rem",
                          borderRadius: "0.8rem",
                        }}
                      >
                        <option value="+91">+91</option>
                      </select>
                      <span className="w-[1px] my-2 bg-[#797D82]"></span>
                      <input
                        type="tel"
                        id="phone-number"
                        value={companyDetails.mobileNumber}
                        onChange={(e) =>
                          updateCompanyData("mobileNumber", e.target.value)
                        }
                        className="w-full p-2 border-none rounded-r-lg focus:outline-none focus:ring-0"
                        inputMode="numeric"
                        ref={(el) => (inputRefs.current["mobileNumber"] = el)}
                        maxLength={10}
                      />
                    </div>
                    {errors.mobileNumber && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.mobileNumber}
                      </p>
                    )}
                  </div>
  
                  <div className="grid grid-cols-1 gap-4">
                    <div className="flex flex-col">
                      <label
                        htmlFor="employee-count"
                        className="text-[#797D82] text-base font-normal mb-1"
                      >
                        Expected checks per year
                      </label>
                      <div className="relative focus-within:border-[#1571B7] focus-within:shadow-sm focus-within:shadow-[#1571B7] border border-gray-300 rounded-lg">
                        <select
                          id="checks-per-year"
                          value={companyDetails.expectedChecks}
                          onChange={(e) =>
                            updateCompanyData("expectedChecks", e.target.value)
                          }
                          className="w-full p-2 border-none rounded-lg focus:outline-none appearance-none pr-8"
                          style={{
                            backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="%23797D82" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>')`,
                            backgroundPosition: "right 1rem center",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "1.5rem",
                          }}
                        >
                          <option value="">Select Option</option>
                          <option value="1-10">1-10</option>
                          <option value="11-25">11-25</option>
                          <option value="26-50">26-50</option>
                          <option value="51-299">51-299</option>
                          <option value="300-1000">300-1000</option>
                          <option value="1000+">1000+</option>
                        </select>
                      </div>
                      {errors.expectedChecks && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.expectedChecks}
                        </p>
                      )}
                    </div>
                  </div>
  
                  <div className="text-center">
                    <button
                      type="submit"
                      className="self-center book_demo_btn home_button mb-14 px-6 py-3.5 mt-4 ml-2.5 max-w-full text-base font-medium text-white shadow-sm rounded-[61px] w-[182px] max-md:px-5 max-md:mt-10"
                    >
                      Continue
                    </button>
                  </div>
                </form> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GetAQuote;
